<template>
    <div class="card m-0 pl-3 p-2">
        <div>
            <h5 class="title">
                {{ question.quiz_question[0].question }}
            </h5>
        </div>
        <div class="pt-1" v-if="!form.quiz_choice_id">
            <img
                class="pr-2"
                v-for="choice in choices"
                :key="choice.id"
                :src="choice.value"
                style="cursor: pointer"
                @click="
                    form.quiz_choice_id = choice.id
                    form.choiceImg = choice.value
                "
            />
        </div>
        <b-row v-else no-gutters>
            <b-col sm="12" md="12" lg="9" xl="10" class="pr-0">
                <b-row no-gutters>
                    <b-col cols="1">
                        <img :src="form.choiceImg" />
                    </b-col>
                    <b-col class="wrapper-input" cols="11">
                        <b-form-input
                            :placeholder="
                                question.can_comment
                                    ? $t('moodPulse.pendencyPlaceholder')
                                    : $t('moodPulse.commentDisabled')
                            "
                            v-model="form.comment"
                            type="text"
                            class="input-size"
                            :disabled="!question.can_comment"
                        />
                    </b-col>
                </b-row>
                <div class="p-0 mt-2 text-muted">
                    <b-form-checkbox v-model="form.anonymous" v-if="!!question.can_anonymous" size="sm"
                        >{{ $t('profile.pendencies.answerAnonymously') }}
                    </b-form-checkbox>
                </div>
            </b-col>
            <b-col sm="12" md="12" lg="3" xl="2" style="margin-left: -10px" class="mt-1">
                <div class="text-right">
                    <b-button
                        id="btn-humor-user-cancel-question"
                        class="button text-muted"
                        size="sm"
                        variant="outline"
                        active-class="active"
                        @click="clearComment"
                        >{{ $t('form.button.cancel') }}</b-button
                    >
                    <b-button
                        id="btn-humor-user-send-answer"
                        class="button"
                        size="sm"
                        variant="primary"
                        :disabled="!!question.must_comment && !form.comment"
                        @click="saveComment(question.id)"
                        >{{ $t('form.button.send') }}
                    </b-button>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { choices } from '@/views/mood-pulse/constants'
import { saveHumorAnswer } from '../../api'
import { proceedWithConfirmation } from '@/lib/sweet-alert'
import notification, { success, danger } from '@/lib/notification'

notification.init()

export default {
    props: {
        question: {
            required: true,
        },
        update: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            choices,
            form: {
                comment: null,
                anonymous: false,
                quiz_choice_id: null,
                choiceImg: null,
            },
        }
    },
    methods: {
        clearComment() {
            this.form = {
                comment: null,
                anonymous: false,
                quiz_choice_id: null,
                choiceImg: null,
            }
        },
        saveComment(id) {
            this.form.quiz_quiz_id = id
            proceedWithConfirmation({
                message: this.$t('notification.sendENPSAnswer'),
                onConfirm: () => saveHumorAnswer(this.form),
                callback: () => {
                    success(this.$t('notification.answerSentSuccessfully'))
                    this.update()
                },
                onError: () => danger(),
            })
        },
    },
}
</script>

<style scoped>
.title {
    font-size: 16px;
}
.dark-text {
    color: #3b3f4e;
}
.active {
    background-color: white;
}
.button {
    width: 50%;
    border-radius: 5px;
    font-weight: bold;
}

@media (min-width: 1475px) {
    .input-size {
        width: 100%;
    }
    .wrapper-input {
        margin-left: -30px;
    }
}

@media (max-width: 1474px) and (min-width: 1265px) {
    .input-size {
        width: 100%;
    }
    .wrapper-input {
        margin-left: -20px;
    }
}

@media (max-width: 1264px) and (min-width: 1186px) {
    .input-size {
        width: 96%;
    }
    .wrapper-input {
        margin-left: -5px;
    }
}

@media (max-width: 1185px) {
    .input-size {
        width: 96%;
    }
    .wrapper-input {
        margin-left: 0px;
    }
}
</style>
